module.exports = __webpack_public_path__ + "static/logo-53c8264cd12b3925ed44e0a981ac0099.svg";